import BaseModel from '@/data/models/base/base-model';
import TypeUtils from '@/helpers/type-utils';

export default class MeterReadingMonthlyAggregated extends BaseModel {

  meterId: string;
  month: number;
  year: number;
  value: number;
  count: number;
  date: Date;

  static map(data: Partial<MeterReadingMonthlyAggregated>): MeterReadingMonthlyAggregated | null {
    if (!data) {
      return null;
    }

    const meterReadingMonthlyAggregated = new MeterReadingMonthlyAggregated();

    meterReadingMonthlyAggregated.meterId = TypeUtils.hasStringOrDefault(data.meterId);
    meterReadingMonthlyAggregated.month = TypeUtils.hasNumberOrDefault(data.month);
    meterReadingMonthlyAggregated.year = TypeUtils.hasNumberOrDefault(data.year);
    meterReadingMonthlyAggregated.value = TypeUtils.hasNumberOrDefault(data.value);
    meterReadingMonthlyAggregated.count = TypeUtils.hasNumberOrDefault(data.count);
    meterReadingMonthlyAggregated.date = TypeUtils.hasDateOrDefault(data.date);

    return meterReadingMonthlyAggregated;
  }

}
